const PT_BR = "PT_BR"
const EN = "EN"
const ES = "ES"

export default { PT_BR,EN,ES }